<div class="subpage-container">
  <div class="container g-0 m-0">
    <div class="row g-0 m-0 d-flex align-items-center pt-4">
      <div class="col-md-9 ps-5 pt-2 pb-4">
        <h2 class="col pb-2 title">
          {{ "UTILITIES" | translate }}
        </h2>
        <h6 class="col subtitle">{{ "UTILITY_SUBTITLE" | translate }}</h6>
      </div>
      <div class="col-md-3 d-flex justify-content-end gap-3 pe-5 text-nowrap">

        <button class="col-auto button-add-device justify-content-center text-nowrap"
          [routerLink]="['../utilities/utility-setup']">
          {{'ADD_UTILITY' | translate}}
        </button>
      </div>
    </div>
    <div class="row g-0 m-0 pt-2">
      <router-outlet></router-outlet>
    </div>
  </div>